export default {
  loadingWebsites: "Carga de sitios...",
  website: "Sitio web",
  websiteLoading: "Carga de organismos",
};
